import React from 'react';
import { FormattedDate } from 'react-intl';
import { useFelaEnhanced } from '@ackee/fela';

import { Language } from 'config/language';

import { PostAuthorLink } from '../PostAuthorLink';
import { PostCategoriesList } from '../PostCategoriesList';
import type { PostAuthor, PostCategory } from '../../types';

import * as felaRules from './BlogPostMeta.rules';

export interface BlogPostMetaProps {
    author: PostAuthor;
    categories: PostCategory[];
    publishedAt: string;
    languageMutation?: Language;
}

export const BlogPostMeta = ({ author, categories, publishedAt, languageMutation }: BlogPostMetaProps) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <div className={styles.container}>
            <span className={styles.author}>
                <PostAuthorLink displayPhoto author={author} languageMutation={languageMutation} />
            </span>
            <span className={styles.categories}>
                <PostCategoriesList categories={categories} languageMutation={languageMutation} />
            </span>
            <span className={styles.date}>
                <FormattedDate value={publishedAt} year="numeric" month="long" day="2-digit" />
            </span>
        </div>
    );
};
